export const primaryNavigation = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About" },
];

export const footerNavigation = [
  ...primaryNavigation,
  { to: "/contact", label: "Contact" },
];

export const legalNavigation = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-conditions", label: "Terms & Conditions" },
];
